import { render, staticRenderFns } from "./ServicePDF.vue?vue&type=template&id=3674e716"
import script from "./ServicePDF.vue?vue&type=script&lang=js"
export * from "./ServicePDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports